export default __webpack_public_path__ + "static/media/cal_bg9.7a02e6b5.jpg";